import { Appearance, CssFontSource } from "@stripe/stripe-js";

// Stripe's iframes need their own copy of the app's font; they cannot inherit its stylesheet.
export const stripeFonts: CssFontSource[] = [
  { cssSrc: "https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap" },
];

export const getStripeAppearance = (): Appearance => {
  const brandRgb = globalThis
    .getComputedStyle(document.documentElement)
    .getPropertyValue("--repeatmd-brand-color")
    .trim()
    .split(/\s+/u)
    .join(", ");

  return {
    theme: "stripe",
    variables: {
      colorPrimary: brandRgb ? `rgb(${brandRgb})` : "#2b5f6a",
      colorBackground: "#ffffff",
      colorText: "#252727",
      colorDanger: "#c73939",
      borderRadius: "8px",
      fontFamily: '"DM Sans", sans-serif',
      fontSizeBase: "16px",
      spacingUnit: "4px",
    },
    rules: {
      ".Input": {
        border: "1px solid #d7dada",
        boxShadow: "none",
        padding: "12px",
      },
      ".Input:focus": {
        borderColor: brandRgb ? `rgb(${brandRgb})` : "#2b5f6a",
        boxShadow: "none",
      },
      ".Label": {
        color: "#4d5151",
        fontWeight: "500",
      },
    },
  };
};
